import { RoomDTO } from '../../dto/location/room.dto';

export class Room {
    guid: string;
    room_name: string;
    location_guid: string;
    capacity: number;
    description?: string;
    /** Display name from list endpoints when joined with location. */
    locations_name?: string;

    constructor(
        guid: string,
        room_name: string,
        location_guid: string,
        capacity: number,
        description?: string
    ) {
        this.guid = guid;
        this.room_name = room_name;
        this.location_guid = location_guid;
        this.capacity = capacity;
        this.description = description;
    }

    static fromDTO(dto: RoomDTO): Room {
        const r = new Room(
            dto.guid,
            dto.room_name,
            dto.location_guid,
            dto.capacity,
            dto.description
        );
        r.locations_name = dto.locations_name;
        return r;
    }

    static toDTO(model: Room): RoomDTO {
        return {
            guid: model.guid,
            room_name: model.room_name,
            location_guid: model.location_guid,
            capacity: model.capacity,
            description: model.description,
            locations_name: model.locations_name
        };
    }
} 